// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-border[data-v-a1f54bbe] {\n    border-right: 1px solid white;\n    width: 165px;\n}\n.custom-border[data-v-a1f54bbe]:last-child {\n    border-right: none;\n}\n.custom-text[data-v-a1f54bbe] {\n    max-width: 135px;\n}\n@media only screen and (width <= 960px) {\n.custom-border[data-v-a1f54bbe] {\n        border-right: none;\n}\n.custom-text[data-v-a1f54bbe] {\n        max-width: 100%;\n}\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
